import { render } from "./AddRobotTaskView.vue?vue&type=template&id=2fcc0639&scoped=true"
import script from "./AddRobotTaskView.vue?vue&type=script&lang=js"
export * from "./AddRobotTaskView.vue?vue&type=script&lang=js"

import "./AddRobotTaskView.vue?vue&type=style&index=0&id=2fcc0639&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fcc0639"]])

export default __exports__